export const portalConstants = {
    SET_PORTAL_SETTINGS: 'SET_PORTAL_SETTINGS',
    PAGE_UPDATED: 'PAGE_UPDATED',
    FLOATING_PAGE_UPDATED: 'FLOATING_PAGE_UPDATED',
    PORTAL_LOADING: 'PORTAL_LOADING',
    AFFILIATE_VALIDATED: 'AFFILIATE_VALIDATED',
    SET_IS_SUBMITTING: 'SET_IS_SUBMITTING',
};
